console.log('[Pickeasy Wag Bags Lead Time] File loaded');

(function () {
  const TARGET_PRODUCT_IDS = new Set([
    7736287428675, // Cheezies Wag Bags
    7736287723587, // Bark-Kwa Pork Wag Bags
    7736288051267, // Bark-Kwa Beef Wag Bags
    7736288215107  // Something Fishy Wag Bags
  ]);

  const STORE_TIMEZONE = 'Asia/Singapore';
  const DISABLED_ATTR = 'data-wagbag-leadtime-disabled';

  const MONTHS = {
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11
  };

  const MONTH_REGEX =
    /\b(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{4})\b/i;

  let currentQuantity = 0;
  let currentLeadDays = 0;
  let earliestDateStamp = null;

  let cartTimer = null;
  let calendarTimer = null;

  /*
  |--------------------------------------------------------------------------
  | Singapore Time
  |--------------------------------------------------------------------------
  */

  function getSingaporeNow() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: STORE_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());

    const result = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        result[part.type] = Number(part.value);
      }
    });

    return result;
  }

  /*
  |--------------------------------------------------------------------------
  | Lead Time Rules
  |--------------------------------------------------------------------------
  */

  function getLeadDays(quantity) {
    const singaporeTime = getSingaporeNow();
    const isAfter4PM = singaporeTime.hour >= 16;

    if (quantity >= 1 && quantity <= 30) {
      return 1;
    }

    if (quantity >= 31 && quantity <= 34) {
      return 3;
    }

    if (quantity >= 35 && quantity <= 50) {
      return isAfter4PM ? 4 : 3;
    }

    return 0;
  }

  function getEarliestDateStamp(leadDays) {
    if (!leadDays) {
      return null;
    }

    const singaporeTime = getSingaporeNow();

    const today = Date.UTC(
      singaporeTime.year,
      singaporeTime.month - 1,
      singaporeTime.day
    );

    return today + leadDays * 86400000;
  }

  function formatDateStamp(timestamp) {
    if (!timestamp) {
      return 'None';
    }

    return new Date(timestamp)
      .toISOString()
      .slice(0, 10);
  }

  /*
  |--------------------------------------------------------------------------
  | Pickeasy Calendar Detection
  |--------------------------------------------------------------------------
  */

  function isVisible(element) {
    if (!element) {
      return false;
    }

    const style = window.getComputedStyle(element);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden'
    ) {
      return false;
    }

    const rect = element.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0;
  }

  function hasCalendarWeekdays(text) {
    const weekdays = [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat'
    ];

    let found = 0;

    weekdays.forEach(function (day) {
      const regex = new RegExp(
        '\\b' + day + '\\b',
        'i'
      );

      if (regex.test(text)) {
        found++;
      }
    });

    return found >= 5;
  }

  function findCalendarContainer(element) {
    let node = element;

    for (let i = 0; i < 12 && node; i++) {
      const text = (
        node.innerText ||
        node.textContent ||
        ''
      ).trim();

      if (
        MONTH_REGEX.test(text) &&
        hasCalendarWeekdays(text)
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return null;
  }

  function getMonthYear(container) {
    if (!container) {
      return null;
    }

    const text =
      container.innerText ||
      container.textContent ||
      '';

    const match = text.match(MONTH_REGEX);

    if (!match) {
      return null;
    }

    return {
      month:
        MONTHS[match[1].toLowerCase()],
      year:
        Number(match[2])
    };
  }

  function isCalendarDayNumber(element) {
    const text = (
      element.textContent || ''
    ).trim();

    if (!/^\d{1,2}$/.test(text)) {
      return false;
    }

    const day = Number(text);

    return day >= 1 && day <= 31;
  }

  function getPickeasyCalendarDays() {
    const results = [];
    const addedElements = new Set();

    /*
     * First try normal clickable calendar elements.
     */
    const selectors = [
      'button',
      '[role="button"]',
      '[role="gridcell"]',
      'td',
      '[tabindex]'
    ];

    document
      .querySelectorAll(selectors.join(','))
      .forEach(function (element) {
        if (!isVisible(element)) {
          return;
        }

        if (!isCalendarDayNumber(element)) {
          return;
        }

        const container =
          findCalendarContainer(element);

        if (!container) {
          return;
        }

        const monthYear =
          getMonthYear(container);

        if (!monthYear) {
          return;
        }

        const day =
          Number(
            element.textContent.trim()
          );

        /*
         * Skip obvious previous/next month days.
         */
        const classText =
          (
            (element.className || '') +
            ' ' +
            (
              element.parentElement
                ? element.parentElement.className || ''
                : ''
            )
          ).toLowerCase();

        if (
          classText.includes('outside') ||
          classText.includes('other-month') ||
          classText.includes('outside-month')
        ) {
          return;
        }

        const timestamp = Date.UTC(
          monthYear.year,
          monthYear.month,
          day
        );

        if (!addedElements.has(element)) {
          addedElements.add(element);

          results.push({
            element: element,
            day: day,
            month: monthYear.month,
            year: monthYear.year,
            timestamp: timestamp
          });
        }
      });

    /*
     * Fallback for Pickeasy calendars where dates
     * are simple DIV/SPAN elements.
     */
    if (results.length === 0) {
      document
        .querySelectorAll('span, div')
        .forEach(function (element) {
          if (!isVisible(element)) {
            return;
          }

          if (!isCalendarDayNumber(element)) {
            return;
          }

          const container =
            findCalendarContainer(element);

          if (!container) {
            return;
          }

          const monthYear =
            getMonthYear(container);

          if (!monthYear) {
            return;
          }

          let clickable =
            element.closest(
              'button, [role="button"], [role="gridcell"], [tabindex]'
            );

          if (
            !clickable ||
            !container.contains(clickable)
          ) {
            clickable = element;
          }

          if (addedElements.has(clickable)) {
            return;
          }

          const day =
            Number(
              element.textContent.trim()
            );

          const timestamp = Date.UTC(
            monthYear.year,
            monthYear.month,
            day
          );

          addedElements.add(clickable);

          results.push({
            element: clickable,
            day: day,
            month: monthYear.month,
            year: monthYear.year,
            timestamp: timestamp
          });
        });
    }

    return results;
  }

  /*
  |--------------------------------------------------------------------------
  | Disable / Enable Only Our Custom Dates
  |--------------------------------------------------------------------------
  */

  function clearCustomDisabledDates() {
    document
      .querySelectorAll(
        '[' + DISABLED_ATTR + '="true"]'
      )
      .forEach(function (element) {
        element.removeAttribute(
          DISABLED_ATTR
        );
      });
  }

  function applyLeadTimeToCalendar() {
    clearCustomDisabledDates();

    if (!earliestDateStamp) {
      return;
    }

    const calendarDays =
      getPickeasyCalendarDays();

    let disabledCount = 0;

    calendarDays.forEach(function (item) {
      if (
        item.timestamp <
        earliestDateStamp
      ) {
        item.element.setAttribute(
          DISABLED_ATTR,
          'true'
        );

        disabledCount++;
      }
    });

    console.log(
      '[Pickeasy Wag Bags Lead Time] Calendar days found:',
      calendarDays.length
    );

    console.log(
      '[Pickeasy Wag Bags Lead Time] Custom dates disabled:',
      disabledCount
    );
  }

  /*
  |--------------------------------------------------------------------------
  | Cart Quantity
  |--------------------------------------------------------------------------
  */

  async function getCart() {
    const response = await fetch(
      '/cart.js',
      {
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Could not load Shopify cart'
      );
    }

    return response.json();
  }

  async function calculateLeadTime() {
    try {
      const cart = await getCart();

      let quantity = 0;

      cart.items.forEach(function (item) {
        const productId =
          Number(item.product_id);

        if (
          TARGET_PRODUCT_IDS.has(
            productId
          )
        ) {
          quantity +=
            Number(item.quantity || 0);
        }
      });

      currentQuantity = quantity;

      currentLeadDays =
        getLeadDays(
          currentQuantity
        );

      earliestDateStamp =
        getEarliestDateStamp(
          currentLeadDays
        );

      const sg =
        getSingaporeNow();

      console.log(
        '[Pickeasy Wag Bags Lead Time] Singapore time:',
        sg
      );

      console.log(
        '[Pickeasy Wag Bags Lead Time] Wag Bag quantity:',
        currentQuantity
      );

      console.log(
        '[Pickeasy Wag Bags Lead Time] Lead days:',
        currentLeadDays
      );

      console.log(
        '[Pickeasy Wag Bags Lead Time] Earliest date:',
        formatDateStamp(
          earliestDateStamp
        )
      );

      applyLeadTimeToCalendar();

      /*
       * Pickeasy can redraw its calendar
       * after our first run.
       */
      setTimeout(
        applyLeadTimeToCalendar,
        300
      );

      setTimeout(
        applyLeadTimeToCalendar,
        800
      );

      setTimeout(
        applyLeadTimeToCalendar,
        1500
      );

    } catch (error) {
      console.error(
        '[Pickeasy Wag Bags Lead Time] Error:',
        error
      );
    }
  }

  /*
  |--------------------------------------------------------------------------
  | Stop Customer Selecting Our Disabled Dates
  |--------------------------------------------------------------------------
  */

  function blockDisabledDate(event) {
    const disabledDate =
      event.target.closest(
        '[' +
        DISABLED_ATTR +
        '="true"]'
      );

    if (!disabledDate) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    console.log(
      '[Pickeasy Wag Bags Lead Time] Blocked unavailable date'
    );

    return false;
  }

  document.addEventListener(
    'click',
    blockDisabledDate,
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }

      blockDisabledDate(event);
    },
    true
  );

  /*
  |--------------------------------------------------------------------------
  | Quantity Changes
  |--------------------------------------------------------------------------
  */

  function scheduleCartRefresh() {
    clearTimeout(cartTimer);

    cartTimer =
      setTimeout(
        calculateLeadTime,
        500
      );

    setTimeout(
      calculateLeadTime,
      1000
    );

    setTimeout(
      calculateLeadTime,
      1800
    );
  }

  function scheduleCalendarRefresh() {
    clearTimeout(calendarTimer);

    calendarTimer =
      setTimeout(
        applyLeadTimeToCalendar,
        100
      );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest(
          '.quantity__button'
        ) ||
        event.target.closest(
          '.quantity'
        ) ||
        event.target.closest(
          '[name="updates[]"]'
        )
      ) {
        scheduleCartRefresh();
      }

      /*
       * Calendar next/previous month.
       */
      scheduleCalendarRefresh();

      setTimeout(
        applyLeadTimeToCalendar,
        400
      );
    }
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.matches(
          '[name="updates[]"]'
        ) ||
        event.target.matches(
          'input[type="number"]'
        )
      ) {
        scheduleCartRefresh();
      }

      scheduleCalendarRefresh();
    }
  );

  /*
   * Common Shopify/theme cart events.
   */
  document.addEventListener(
    'cart:updated',
    scheduleCartRefresh
  );

  document.addEventListener(
    'cart:change',
    scheduleCartRefresh
  );

  document.addEventListener(
    'cart:refresh',
    scheduleCartRefresh
  );

  /*
  |--------------------------------------------------------------------------
  | Pickeasy DOM Observer
  |--------------------------------------------------------------------------
  */

  const observer =
    new MutationObserver(function (
      mutations
    ) {
      let shouldRefresh = false;

      mutations.forEach(
        function (mutation) {
          if (
            mutation.addedNodes &&
            mutation.addedNodes.length
          ) {
            shouldRefresh = true;
          }
        }
      );

      if (shouldRefresh) {
        scheduleCalendarRefresh();
      }
    });

  /*
  |--------------------------------------------------------------------------
  | CSS
  |--------------------------------------------------------------------------
  */

  function addStyles() {
    if (
      document.getElementById(
        'wagbag-pickeasy-leadtime-css'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'wagbag-pickeasy-leadtime-css';

    style.textContent = `
      [${DISABLED_ATTR}="true"] {
        opacity: 0.25 !important;
        cursor: not-allowed !important;
      }

      [${DISABLED_ATTR}="true"] * {
        cursor: not-allowed !important;
      }
    `;

    document.head.appendChild(
      style
    );
  }

  /*
  |--------------------------------------------------------------------------
  | Debug Helper
  |--------------------------------------------------------------------------
  */

  window.WagBagLeadTimeDebug = {
    recalculate:
      calculateLeadTime,

    refreshCalendar:
      applyLeadTimeToCalendar,

    getState: function () {
      return {
        quantity:
          currentQuantity,

        leadDays:
          currentLeadDays,

        earliestDate:
          formatDateStamp(
            earliestDateStamp
          ),

        calendarDaysFound:
          getPickeasyCalendarDays()
            .length
      };
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Init
  |--------------------------------------------------------------------------
  */

  function init() {
    addStyles();

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    calculateLeadTime();

    setTimeout(
      calculateLeadTime,
      1000
    );

    setTimeout(
      applyLeadTimeToCalendar,
      2000
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();